// src/components/Footer.jsx
import React from "react";
import {
  Mail,
  Phone,
  MapPin,
  Facebook,
  Instagram,
  Linkedin,
  MessageCircle,
} from "lucide-react";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  const goToPage = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="bg-[var(--aerzen-black)] text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* MAIN FOOTER */}
        <div className="grid md:grid-cols-4 gap-12 mb-12">

          {/* BRAND */}
          <div className="space-y-4">
            <img
              src="/assets/aerzen-logo-white.png"
              alt="AERZEN AIR™"
              className="h-12 w-auto cursor-pointer"
              onClick={() => goToPage("/")}
            />

            <p className="text-white/70 leading-relaxed">
              AERZEN AIR™ develops clean-air systems and air purification
              solutions designed for Indian indoor and public environments.
            </p>

            {/* SOCIAL */}
            <div className="flex items-center space-x-4 mt-4">
              <a
                href="https://www.facebook.com/aerzenair"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <Facebook className="h-5 w-5 hover:text-white transition" />
              </a>

              <a
                href="https://www.instagram.com/aerzenair/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5 hover:text-white transition" />
              </a>

              <a
                href="https://www.linkedin.com/company/aerzen-air/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <Linkedin className="h-5 w-5 hover:text-white transition" />
              </a>

              <a
                href="https://wa.me/919540404657"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
              >
                <MessageCircle className="h-5 w-5 hover:text-white transition" />
              </a>
            </div>
          </div>

          {/* QUICK LINKS */}
          <div>
            <h3 className="font-bold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li><button onClick={() => goToPage("/")}>Home</button></li>
              <li><button onClick={() => goToPage("/products")}>Products</button></li>
              <li><button onClick={() => goToPage("/prebook")}>Pre-Book</button></li>
              <li>
                <button onClick={() => goToPage("/initiatives/airshield-transit-zone")}>
                  AirShield™ Transit Zone
                </button>
              </li>
            </ul>
          </div>

          {/* RESPONSIBILITY */}
          <div>
            <h3 className="font-bold text-lg mb-4">Responsibility</h3>
            <ul className="space-y-3">
              <li><button onClick={() => goToPage("/vision")}>Vision</button></li>
              <li><button onClick={() => goToPage("/mission")}>Mission</button></li>
              <li>
                <button onClick={() => goToPage("/environmental-responsibility")}>
                  Sustainability
                </button>
              </li>
            </ul>
          </div>

          {/* CONTACT */}
          <div>
            <h3 className="font-bold text-lg mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex gap-3">
                <Mail className="h-5 w-5 text-[var(--aerzen-blue)]" />
                <a href="mailto:support@aerzenair.com">
                  support@aerzenair.com
                </a>
              </li>
              <li className="flex gap-3">
                <Phone className="h-5 w-5 text-[var(--aerzen-blue)]" />
                <a href="tel:+919540404657">+91 95404 04657</a>
              </li>
              <li className="flex gap-3">
                <MapPin className="h-5 w-5 text-[var(--aerzen-blue)]" />
                <span>Greater Noida, Uttar Pradesh, India</span>
              </li>
            </ul>
          </div>
        </div>

        {/* MSME */}
        <div className="flex items-center justify-center gap-3 mb-6">
          <img
            src="/assets/msme-logo.png"
            alt="Registered under MSME"
            className="h-8 opacity-80"
          />
          <span className="text-sm text-white/70">
            Registered under MSME (India)
          </span>
        </div>

        {/* CREDIT */}
        <div className="max-w-7xl mx-auto px-4 mb-4">
          <p className="text-xs text-white/50 text-left">
            Designed &amp; Maintained by <strong>Rudransh Tech</strong>
          </p>
        </div>

        {/* LEGAL */}
        <div className="text-xs text-white/50 text-center space-y-2 max-w-4xl mx-auto">
          <div className="flex justify-center gap-6 flex-wrap">
            <button onClick={() => goToPage("/privacy")}>Privacy Policy</button>
            <button onClick={() => goToPage("/refund")}>Refund Policy</button>
            <button onClick={() => goToPage("/shipping")}>Delivery Policy</button>
          </div>

          <p>
            Air quality information displayed is indicative and based on publicly
            available data. AERZEN AIR™ does not represent any government body.
          </p>

          <p>
            © {new Date().getFullYear()} AERZEN AIR™. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
